import * as ko from "knockout";
import {hasher} from 'hasher';
import {Permission, WIN_NAME_DOCS} from "../../constants";
import {KOSubscriptionTracker} from "../../util/KOSubscriptionTracker";
import {nsFa} from "../fa/fn";
import {ITranslationParams, TBaseOrObservableType} from "../../index";
import {storeObservable} from "../../util/sessionstore";
import i = nsFa.i;

export interface ICustomButton {
    canSeeOwnPage?: boolean
    onClick?: Function
    cls: string // i.e. "fa-plus"
    permissionLevel?: Permission
    target?: string
    label: string | ITranslationParams
    description?: string | ITranslationParams
    href?: string
}

export interface IParams {
    badge: TBaseOrObservableType<string>
    customButtons: ICustomButton[] | KnockoutObservableArray<ICustomButton>
    helpClick: string
    icon: string
    isBig?: boolean;
    isWaiting: TBaseOrObservableType<boolean>
    label: TBaseOrObservableType<string>
}

export class AbstractHeading {

    icon!: string;
    label: TBaseOrObservableType<string>;
    isWaiting: TBaseOrObservableType<boolean>;
    private kosub: KOSubscriptionTracker = new KOSubscriptionTracker();

    constructor(protected params: IParams) {
        this.label = params.label;
        this.isWaiting = params.isWaiting ?? false;
    }

    private getHelpButton(): ICustomButton {
        return {
            cls: "fa-question fas",
            label: "help",
            href: this.params.helpClick,
            target: WIN_NAME_DOCS
        };
    }

    classes = ko.pureComputed((): string => {
        return this.getClasses().join(" ");
    });

    protected getClasses(): string[] {
        return [];
    }

    getIcon(): string | null {
        if (this.params.icon) {
            return i(this.params.icon);
        }
        return null;
    }

    showBadge(): boolean {
        const val = ko.unwrap(this.params.badge);
        return val !== undefined && val !== null;
    }

    getBadge(): string | null {
        const currentLanguage = storeObservable('language')();
        if (this.params.badge !== undefined) {
            const ret = ko.unwrap(this.params.badge);
            if (parseInt(ret)) {
                return parseInt(ret).toLocaleString(currentLanguage.key);
            }
            return ret;
        }
        return null;
    }

    onCustomButtonClick(customButton: ICustomButton) {
        if (customButton.onClick) {
            customButton.onClick();
        } else if (customButton.href) {
            hasher.setHash(customButton.href);
        }
    }

    onKeyUp(vm: any, e: KeyboardEvent) {
        if (e.key == "Enter") {
            e.target?.dispatchEvent(new Event("click"));
        }
    }

    protected customButtons = ko.pureComputed((): ICustomButton[] => {
        let ret = Array.from(ko.unwrap(this.params.customButtons ?? []));
        ret.push(this.getHelpButton());
        return ret;
    })


    dispose() {
        this.kosub.unsuscribeAll();
    }

}
